(() => {
  'use strict';
  const cutoff = Date.parse('2026-10-16T00:00:00+10:00');
  if (!Number.isFinite(cutoff) || Date.now() >= cutoff) return;

  const checkoutSelector = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]';
  let pendingTrigger = null;
  let modal = null;
  let previousFocus = null;
  let previousOverflow = '';
  let approved = false;

  const guardStyle = document.createElement('style');
  guardStyle.id = 'uniq-dispatch-guard-style';
  guardStyle.textContent = '.additional-checkout-buttons,.shopify-payment-button{display:none!important;}';
  document.head.appendChild(guardStyle);

  function buildModal() {
    if (modal) return modal;
    const style = document.createElement('style');
    style.id = 'uniq-dispatch-modal-style';
    style.textContent = '.uniq-dispatch-overlay[hidden]{display:none!important}.uniq-dispatch-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(17,17,17,.58)}.uniq-dispatch-dialog{width:min(100%,520px);background:#fff;color:#1a1a1a;padding:34px 32px 30px;box-shadow:0 24px 70px rgba(0,0,0,.22);text-align:center}.uniq-dispatch-dialog h2{margin:0 0 16px;font:inherit;font-size:25px;line-height:1.2;font-weight:600;letter-spacing:-.02em}.uniq-dispatch-dialog p{margin:0 auto 12px;max-width:430px;font-size:15px;line-height:1.65}.uniq-dispatch-actions{display:grid;gap:10px;margin-top:24px}.uniq-dispatch-primary,.uniq-dispatch-secondary{min-height:48px;border:1px solid #171717;padding:12px 18px;font:inherit;font-size:14px;font-weight:600;cursor:pointer}.uniq-dispatch-primary{background:#171717;color:#fff}.uniq-dispatch-secondary{background:#fff;color:#171717}.uniq-dispatch-primary:focus-visible,.uniq-dispatch-secondary:focus-visible{outline:3px solid currentColor;outline-offset:3px}@media(max-width:520px){.uniq-dispatch-dialog{padding:28px 22px 24px}.uniq-dispatch-dialog h2{font-size:22px}}';
    document.head.appendChild(style);
    modal = document.createElement('div');
    modal.className = 'uniq-dispatch-overlay';
    modal.hidden = true;
    modal.setAttribute('data-nosnippet', '');
    modal.innerHTML = '<div class="uniq-dispatch-dialog" role="dialog" aria-modal="true" aria-labelledby="uniq-dispatch-title" aria-describedby="uniq-dispatch-copy"><h2 id="uniq-dispatch-title">Dispatch Notice</h2><p id="uniq-dispatch-copy">Orders placed during our temporary fulfilment pause will be dispatched after <strong>15 October 2026</strong>.</p><p>Please confirm you’re happy to proceed with this dispatch timeframe.</p><div class="uniq-dispatch-actions"><button type="button" class="uniq-dispatch-primary">I understand, continue to checkout</button><button type="button" class="uniq-dispatch-secondary">Go back</button></div></div>';
    modal.querySelector('.uniq-dispatch-primary').addEventListener('click', proceed);
    modal.querySelector('.uniq-dispatch-secondary').addEventListener('click', closeModal);
    modal.addEventListener('keydown', trapFocus);
    document.body.appendChild(modal);
    return modal;
  }

  function openModal(trigger) {
    pendingTrigger = trigger;
    previousFocus = document.activeElement;
    const node = buildModal();
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    node.hidden = false;
    node.querySelector('.uniq-dispatch-primary').focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = previousOverflow;
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    pendingTrigger = null;
  }

  function proceed() {
    const trigger = pendingTrigger;
    if (!trigger) return;
    if (modal) modal.hidden = true;
    document.body.style.overflow = previousOverflow;
    approved = true;
    window.setTimeout(() => { approved = false; }, 2000);

    if (trigger.matches('a[href]')) {
      window.location.assign(trigger.href);
      return;
    }

    if (typeof trigger.click === 'function') {
      trigger.click();
      return;
    }

    window.location.assign('/checkout');
  }

  function trapFocus(event) {
    if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(modal.querySelectorAll('button:not([disabled])'));
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const trigger = target && target.closest(checkoutSelector);
    if (!trigger || approved) return;
    event.preventDefault();
    event.stopPropagation();
    openModal(trigger);
  }, true);

  document.addEventListener('submit', (event) => {
    if (approved) return;
    const submitter = event.submitter;
    if (!submitter || !submitter.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopPropagation();
    openModal(submitter);
  }, true);
})();
